import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { useGlobalStore } from "@/store/hooks";
import { buildShippingAddressInfo } from "@/utils/OrderUtils";
import { Form } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Select } from "./BaseSelect";

interface ShipperFieldProps {
    shop: ShopDTO;
}

const ShipperField: React.FC<ShipperFieldProps> = function ({ shop }) {
    const globalStore = useGlobalStore();

    if (!shop) return;
    if (shop.type !== ShopType.MANUAL && shop.type !== ShopType.INDEPENDENT_MANUAL) return null;

    return (
        <Form.Item name="shippingAddressId" label={<span className="search-field-label">发货人</span>}>
            <Select
                data-openreplay-masked
                options={[
                    {
                        key: undefined,
                        value: undefined,
                        label: "",
                    },
                    ...(globalStore.waybillPrintStore.shippingAddresses?.map((shippingAddress) => {
                        return {
                            key: shippingAddress.id,
                            value: shippingAddress.id,
                            "data-openreplay-masked": true,
                            label: buildShippingAddressInfo(shippingAddress),
                        };
                    }) ?? []),
                ]}
            />
        </Form.Item>
    );
};

export default observer(ShipperField);
